import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// CSP-safe runtime shims (no new files) — provide no-op ClientAnalytics
// and a Promise-based setImmediate to prevent vendor fallbacks that inject inline scripts.
try {
  const win = window as any;
  if (!win.ClientAnalytics) {
    win.ClientAnalytics = {
      init: () => { /* noop */ },
      identify: () => { /* noop */ },
      logEvent: () => { /* noop */ },
      PlatformName: { web: 'web' }
    };
  }

  if (!win.setImmediate) {
    win.setImmediate = function (fn: (...args: any[]) => any, ...args: any[]) {
      return Promise.resolve().then(() => fn.apply(null, args));
    };
  }
} catch (e) {
  // best-effort — don't block bootstrap
  console && console.warn && console.warn('CSP shims failed to initialise', e);
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
